// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"4ce6237a","453":"91938c32","849":"8bdfb368","895":"926e761a"}[chunkId] + ".chunk.js";
};